export default __webpack_public_path__ + "static/media/premiumFonts.439c901a.svg";